import { useState } from "react";
import { toast } from "react-toastify";
import { Copy, ShieldAlert } from "lucide-react";

import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "../ui/dialog";

/**
 * Mostra uma credencial recém-criada. Uma vez só.
 *
 * O valor inteiro nunca mais volta do servidor: depois daqui a API devolve
 * apenas os quatro últimos caracteres. Por isso o modal não fecha no clique
 * fora nem no Esc — fechar sem querer custa a credencial, e a única saída
 * seria rotacionar e refazer a integração do outro lado.
 */
const CredencialRevelada = ({ aberto, aoFechar, titulo, valor, descricao }) => {
	const [copiado, setCopiado] = useState(false);

	const copiar = async () => {
		try {
			await navigator.clipboard.writeText(valor);
			setCopiado(true);
			toast.success("Copiado.");
		} catch {
			toast.error("Não consegui copiar. Selecione o texto e copie na mão.");
		}
	};

	const fechar = () => {
		setCopiado(false);
		aoFechar();
	};

	return (
		<Dialog open={aberto}>
			<DialogContent
				className="sm:max-w-lg"
				onPointerDownOutside={(e) => e.preventDefault()}
				onEscapeKeyDown={(e) => e.preventDefault()}
				onInteractOutside={(e) => e.preventDefault()}
			>
				<DialogHeader>
					<DialogTitle>{titulo}</DialogTitle>
					<DialogDescription>{descricao}</DialogDescription>
				</DialogHeader>

				<div className="space-y-3">
					<div>
						<Label htmlFor="credencial" className="text-xs">
							Valor
						</Label>
						<div className="mt-1 flex gap-2">
							<Input
								id="credencial"
								readOnly
								value={valor || ""}
								className="font-mono text-xs"
								onFocus={(e) => e.target.select()}
							/>
							<Button
								type="button"
								variant="outline"
								size="icon"
								aria-label="Copiar credencial"
								onClick={copiar}
							>
								<Copy className="h-4 w-4" />
							</Button>
						</div>
					</div>

					<p className="flex gap-1.5 rounded-md bg-muted p-2 text-xs leading-relaxed">
						<ShieldAlert className="mt-0.5 h-3.5 w-3.5 shrink-0" />
						Guarde agora. Este valor não volta a aparecer: depois desta janela o
						sistema mostra só os quatro últimos caracteres. Se perder, o jeito é
						rotacionar e refazer a configuração do outro lado.
					</p>
				</div>

				<DialogFooter>
					<Button type="button" onClick={fechar} disabled={!copiado}>
						{copiado ? "Já guardei, pode fechar" : "Copie antes de fechar"}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default CredencialRevelada;
